export const SemboSizeTypes = {
  LARGE: { w: 123, h: 32 },
  MEDIUM: { w: 92, h: 24 },
  SMALL: { w: 61, h: 16 },
};

export const DTFSizeTypes = {
  LARGE: { w: 122, h: 38 },
  MEDIUM: { w: 92, h: 28 },
  SMALL: { w: 61, h: 20 },
};

export type IconProps = {
  market: 'Sembo' | 'DTF';
};
